import React, { Component } from "react";
import Field from "./Field";

export const FieldGroup = (props) => {

  function toggleCollapse(target) {
    target.parentElement.parentElement.classList.toggle('field-group-collapsed');
    target.classList.toggle('dashicons-fullscreen-alt');
    target.classList.toggle('dashicons-fullscreen-exit-alt');
  }

	return (
		<React.Fragment>
			<h4>{ props.label }</h4>
			{ props.fields.map(
				( el, index ) =>
					<div className='RestRoutesField' key={index}>
					<Field
						group={props.group}
						groupId={props.groupId}
						key={index}
						fieldIndex={ index }
						data={ el }
						currentItem={props.currentItem}
						action={props.action}
					/></div> ) }

		</React.Fragment>
	)
};
